<template>
  <div>
    <h5 class="font-bold ml-5">
      <a-icon class="mr-10" type="unordered-list" />Activity
    </h5>
    <a-table
      :columns="columnsAc"
      :data-source="dataListAc"
      :pagination="false"
      :loading="loadingAc"
      bordered
      class="mb-5"
    >
      <template slot="footer" slot-scope="currentPageData">
        <small class="mt-0 mb-0"
          >count activity : {{ dataListAc.length }} rows</small
        >
      </template>
    </a-table>
  </div>
</template>

<script>
const columnsAc = [
  {
    title: "Term",
    dataIndex: "activity_detail.activity_term",
    scopedSlots: { customRender: "activity_detail.activity_term" },
  },
  {
    title: "Year",
    dataIndex: "activity_detail.activity_year",
    className: "",
    scopedSlots: { customRender: "activity_detail.activity_year" },
  },
  {
    title: "Name [En]",
    dataIndex: "activity_detail.activity_name_eng",
    className: "",
    scopedSlots: { customRender: "activity_detail.activity_name_eng" },
  },
  {
    title: "Position",
    dataIndex: "position",
    className: "",
    scopedSlots: { customRender: "position" },
  },
];
export default {
  data() {
    return {
      columnsAc,
      dataListAc: [],
      loadingAc: false,
    };
  },
  mounted() {
    this.getListEventActivity();
  },
  methods: {
    async getListEventActivity() {
      this.loadingAc = true;
      this.dataListAc = [];
      try {
        const res = await this.$http.get(`/student-activities/member/me/`);
        if (res.status === 200) {
          this.dataListAc = res.data;
          // sort
          if (this.dataListAc.length !== 0) {
            this.dataListAc.sort((a, b) => {
              return (
                b.activity_detail.activity_year -
                a.activity_detail.activity_year
              );
            });
          }
          this.loadingAc = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.loadingAc = false;
        this.dataListAc = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /student-activities/member/me/`,
        });
      }
    },
  },
};
</script>